import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentComponent implements OnInit {

  bTitle = 'ความหมายของ ระยะเวลารอคอยโรค';
  bDescription = 'การเงิน/ประกันสุขภาพและชีวิต';
  bImages = './assets/images/blogs/waiting-period-meaning.jpg';
  bImagesMobile = './assets/images/blogs/waiting-period-meaning-mobile.jpg';
  constructor() { }
  ngOnInit() { }

}
